import { useAuth } from "@clerk/remix";
import { isDefined } from "~/utils/typeguard";

export function useIsImpersonatedSession(): boolean {
  const { actor } = useAuth();
  return isDefined(actor);
}
